import seatsFactory from "../seat";

const SeatsDOMRender = {
  order: 0,
  activate: "seats:rendering",
  run($$) {
    $$.renderSeats = function () {
      $$.seats = {};
      const fragment = $(document.createDocumentFragment());
      if ($$.seatsData.seats && $$.seatsData.seats.length > 0) {
        $$.seatsData.seats.forEach((seat) => {
          $$.seatsWidth = Math.max($$.seatsWidth, seat.x * $$.SEAT_WIDTH);
          $$.seatsHeight = Math.max($$.seatsHeight, seat.y * $$.SEAT_HEIGHT);
          $$.seats[`${seat.row}-${seat.seat}`] = seat;
          return seatsFactory(fragment, seat, $$.SEAT_WIDTH, $$.SEAT_HEIGHT);
        });
      }
      // draw grid

      fragment.appendTo($$.$seats.empty());
      return $$;
    };

    $$.$.on("seats:rendering", $$.renderSeats);
  },
};

window.SectionSeatsDOMRender = SeatsDOMRender;

export default SeatsDOMRender;
